import React from "react";

export default function Error() {
    return <div className="text-center">Something went wrong</div>;
}
